import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsSeriesDetails from "./components/SettingsSeriesDetails";

const SettingsSeriesDetailsApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <SettingsSeriesDetails {...props} />
  </>
);

export default SettingsSeriesDetailsApp;
